import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { REMUNERATION_CONTAINERS_LIST } from 'shared/enums';
import { IMyKnownError, REQUEST_LIFE_CICLE } from 'interfaces/requests';
import { clearNavigationActions } from './helpers';
import { IRemunerationNavigationState } from './interfaces';

export const initialState: IRemunerationNavigationState = {
  mode: REMUNERATION_CONTAINERS_LIST.FLOW,
  loading: REQUEST_LIFE_CICLE.IDLE,
};

export const setRemunerationNavigationAction = createAsyncThunk<
  REMUNERATION_CONTAINERS_LIST,
  REMUNERATION_CONTAINERS_LIST,
  { rejectValue: IMyKnownError }
>('remunerationNavigation/set', async (payload, { dispatch }) => {
  dispatch(clearNavigationActions[payload]());
  return payload;
});

export const resetRemunerationAction = createAsyncThunk<
  IRemunerationNavigationState,
  undefined,
  { rejectValue: IMyKnownError }
>('remunerationModeNavigation/reset', async (_, { dispatch }) => {
  dispatch(clearNavigationActions[initialState.mode]());
  return initialState;
});

const remunerationNavigationSlice = createSlice({
  name: 'remunerationNavigation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setRemunerationNavigationAction.fulfilled,
      (state, { payload }) => {
        state.mode = payload;
        return state;
      },
    );
    builder.addCase(resetRemunerationAction.fulfilled, (state, { payload }) => {
      state.mode = payload.mode;
      state.loading = payload.loading;
      return state;
    });
  },
});
const { reducer } = remunerationNavigationSlice;
export default reducer;
